import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { finalize, take, takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { AppState } from 'src/app/app.state';
import { ClientDashboardService } from 'src/app/client-dashboard/service/client-dashboard.service';
import { ClientDashboardState } from 'src/app/client-dashboard/state/client-dashboard.state';
import {
  ForgotPasswordAlerts,
  ForgotPasswordInputErrorCheck,
  ResetPasswordFields,
} from 'src/app/forgot-password/forgot-password-common-interface';
import { ForgotPasswordService } from 'src/app/forgot-password/forgot-password.service';
import { LoginAlerts, LoginFieldInput, LoginFieldInputErrorCheck } from 'src/app/login/login.interface';
import { LoginService } from 'src/app/login/login.service';
import { OpportunityScannerState } from 'src/app/opportunity-scanner/opportunity-scanner.state';
import { PropertyFilter } from 'src/app/property-filter/interface/property-filter.interface';
import { DialogComponent } from 'src/app/shared/modules/alerts/dialog/dialog.component';
import { LocalStorageService } from 'src/app/shared/service/local-storage.service';
import { ValidatorsService } from 'src/app/shared/service/validators.service';
import { SignupAlerts } from 'src/app/signup/signup.interface';
import { SignupService } from 'src/app/signup/signup.service';
import { VerifyLoginService } from 'src/app/verify-login/verify-login.service';
import { PropertyState } from 'src/app/workspace/state/property.state';
import constants from 'src/constant.json';
import { ListingService } from '../../service/listings.service';
import { UserState } from '../../state/user.state';

const errorObj = { type: 'info', message: '* Please fill mandatory fields' };
declare const google:any;

@Component({
  selector: 'app-signup-dialog',
  templateUrl: './signup-dialog.component.html',
  styleUrls: ['./signup-dialog.component.scss'],
})
export class SignupDialogComponent implements OnInit, AfterViewInit {
  @Input() required: boolean = false;

  @ViewChild('form') form;
  @ViewChild('search') search;
  @ViewChild('forgotPasswordForm') forgotPasswordForm;
   @ViewChild('searchFieldContainer') searchFieldContainer: any;

  userResetToken: string;
  isAddressFocused = false;
  autoCompleteInput: any;
  forgotPasswordField: any = { userName: '' };
  resetPasswordFields: ResetPasswordFields;
  resetPasswordAlerts: ForgotPasswordAlerts = errorObj;
  resetPasswordpatterns: ForgotPasswordInputErrorCheck;
  showResetPwdForm: boolean;
  resetFlag: boolean;
  isPasswordResetSuccessfull: boolean;
  resetLinkInprogress: boolean = false;
  signUpForm: FormGroup;
  isSignup: boolean;
  isSignUpInProgress: boolean = false;
  signupStatus: boolean = false;
  submitted = false;
  signupDetails: any;
  patterns: any;
  interestedAreas = [];
  userId;
  signUpContinueToken = null;
  userAddress;
  alerts: SignupAlerts = errorObj;
  loginFields: LoginFieldInput = { email: '', password: '' };
  loginAlerts: LoginAlerts = errorObj;
  loginPatterns: LoginFieldInputErrorCheck;
  isUserAuthenticationProgress: boolean;
  constant: any = constants;
  isSignUpVisibleSub$ = new BehaviorSubject<boolean>(false);
  isSignUpVisible$ = this.isSignUpVisibleSub$.asObservable();
  isLoginVisibleSub$ = new BehaviorSubject<boolean>(true);
  isLoginVisible$ = this.isLoginVisibleSub$.asObservable();
  isForgotPasswordVisibleSub$ = new BehaviorSubject<boolean>(false);
  isForgotPasswordVisible$ = this.isForgotPasswordVisibleSub$.asObservable();
  autoComplete: any;
  validatingLinkInProgress: boolean;
  websiteUrl: string;
  companyLogo: any;
  companySpecificLogo: string;
  onDestroyNotifier$ = new Subject();
  showPassword: boolean = false;
  companyId: string;
  tab: string;
  openClientDetailsSheet: string;
  encryptedData: any;

  constructor(
    public dialogRef: MatDialogRef<SignupDialogComponent>,
    public formBuilder: FormBuilder,
    public appState: AppState,
    public signupService: SignupService,
    private activatedRoute: ActivatedRoute,
    public validators: ValidatorsService,
    private changeDetect: ChangeDetectorRef,
    public storage: LocalStorageService,
    public loginService: LoginService,
    public router: Router,
    private userState: UserState,
    private appService: AppService,
    private forgotPasswordService: ForgotPasswordService,
    private dialog: MatDialog,
    public verifyLoginService: VerifyLoginService,
    private _route: ActivatedRoute,
    private _router: Router,
    public clientDashboardState: ClientDashboardState,
    private listingService: ListingService,
    private propertyState: PropertyState,
    private opScanState: OpportunityScannerState,
    private clientDashboardService: ClientDashboardService,

    /**
     * `openedFromInterceptor` is true only when the HTTP interceptor opened
     * this dialog after a protected request failed with 401.
     *
     * Normal login, signup, forgot-password and navigation behaviour remains
     * unchanged when this flag is absent or false.
     */
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngAfterViewInit() {
    this.isSignUpVisible$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      setTimeout(() => {
        if (res) this.initAutoComplete();
      }, 200);
    });
  }

  ngOnInit() {
    this.userState.userDetail$.subscribe((res) => {
      this.loginFields.email = res?.user_profile?.email || '';
    });
    this.appState.companyInfo$.subscribe((res: any) => {
      this.companyLogo = res?.logo?.dark || '';
      this.companyId = res?.id;
    });
    this.userId = this.appState?.companyInfoValue?.signUpId;
    this.signUpContinueToken = this.activatedRoute.snapshot.paramMap.get('identifier');
    this.patterns = this.validators.patterns;
    this.signUpForm = this.formBuilder.group({
      firstName: [
        '',
        Validators.compose([Validators.maxLength(25), Validators.pattern('[a-zA-Z ]*'), Validators.required]),
      ],
      lastName: ['', Validators.pattern('[a-zA-Z ]*')],
      email: ['', [Validators.required, Validators.pattern(constants.regex.validEmail)]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      interestedAreas: Validators.compose([Validators.required]),
      autoCompleteInput: '',
      phoneNumber: [''],
    });

    this.phoneNumberRequiredValidator();
    this.resetFlag = false;

    this.tab = this.activatedRoute.snapshot.queryParamMap.get('tab');
    this.openClientDetailsSheet = this.activatedRoute.snapshot.queryParamMap.get('openClientDetails');
    this.encryptedData = this.activatedRoute.snapshot.queryParamMap.get('encryptedData');

  }

  phoneNumberRequiredValidator() {
    const phoneNumberControl = this.signUpForm.get('phoneNumber');
    if (this.appState?.companyInfoValue.isPhoneNumberValidate) {
      phoneNumberControl.setValidators([Validators.required]);
      phoneNumberControl.setValidators(
        Validators.pattern('^(\\+\\d{1,2}\\s?)?1?\\-?\\.?\\s?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$')
      ),
        (this.required = true);
    } else {
      phoneNumberControl.setValidators(
        Validators.pattern('^(\\+\\d{1,2}\\s?)?1?\\-?\\.?\\s?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$')
      ),
        (this.required = false);
    }
    phoneNumberControl.updateValueAndValidity();
  }

  restrictAlphabets(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  get f() {
    return this.signUpForm.controls;
  }

  onUserDetailSubmit() {

    this.submitted = true;
    if (!this.interestedAreas.length) {
      this.signUpForm.controls.interestedAreas.setErrors({ message: 'Interested Areas is required' });
      return;
    }
    if (this.signUpForm.invalid) {
      return;
    }
    if (this.isSignUpInProgress) {
      return;
    }
    this.signupDetails = this.signUpForm.value;
    const isOpportunityClicked = this.opScanState.isOpportunityClicked;
    const signUpObject = {
      email: this.signupDetails.email.toLowerCase(),
      firstName: this.signupDetails.firstName,
      lastName: this.signupDetails.lastName,
      phone: this.signupDetails.phoneNumber,
      password: this.signupDetails.password,
      role: 'employee',
      userId: this.userId,
      domain: this.appState.appBaseUrlValue,
      interestedAreas: this.interestedAreas,
      createdBy: '',
      source: isOpportunityClicked? constants.SIGN_UP.source.opportunityPage:constants.SIGN_UP.source.signUpDialog,
      ...(isOpportunityClicked && {
        opportunityAddress:
          this.propertyState.activePropertyDetailsValue['basic'].Address,
      }),
    };

    this.isSignUpInProgress = true;

    this.signupService
      .createUser(signUpObject)
      .pipe(
        takeUntil(this.onDestroyNotifier$),
        finalize(() => {
          this.isSignUpInProgress = false;
          // set default filter after signup
          let defaultPropertyFilter = this.appState.companyInfoValue?.defaultPropertyFilter;
          let queryParams: Record<string, any> = JSON.parse(JSON.stringify(this._route.snapshot.queryParams));
          if (defaultPropertyFilter) {
            const defaultFilter: Partial<PropertyFilter> = defaultPropertyFilter;
            queryParams = { ...queryParams, ...defaultFilter };
            this._router.navigate([], {
              queryParams,
              queryParamsHandling: 'merge',
            });
          }
        })
      )
      .subscribe(
        (response) => {
          this.opScanState.isOpportunityClicked = false;
          if (!response?.data) return;
          this.submitted = false;
          if (!response?.data?.emailVerificationDate) {
            this.signupStatus = true;
          } else {
            this.signupStatus = false;
            this.onNoClick();
          }
        },
        ({ error }: HttpErrorResponse) => {
          this.alerts = { type: 'error', message: error.message };
          setTimeout(() => {
            this.alerts = errorObj;
          }, 3000);
        }
      );


  }

  addAddress() {
    if (this.userAddress && this.userAddress.address_components) {
      let locality = this.userAddress.address_components.find((address) => address.types.includes('locality'));
      if (!locality)
        locality = this.userAddress.address_components.find((address) =>
          address.types.includes('administrative_area_level_3')
        );
      let state = this.userAddress.address_components.find((address) =>
        address.types.includes('administrative_area_level_1')
      );
      if (locality && state) {
        let addressStatus = this.interestedAreas.find((address) => {
          return address.locality == locality.long_name && address.state == state.short_name;
        });
        if (!addressStatus) {
          this.interestedAreas.push({
            locality: locality.long_name ? locality.long_name : '',
            state: state.short_name ? state.short_name : '',
          });
        }
        this.signUpForm.controls.interestedAreas.setErrors(null);
        this.userAddress = {};
        this.f.autoCompleteInput.setValue(' ');
        this.changeDetect.detectChanges();
      }
    }
  }

  deleteAddress(index) {
    this.interestedAreas.splice(index, 1);
    if(this.interestedAreas.length == 0 && this.autoComplete.value == ''){
      this.autoCompleteInput =''
    }
    this.changeDetect.detectChanges();
  }

  async initAutoComplete() {
    if (!this.searchFieldContainer) {
    return;
    }
    const placesLibrary = await google.maps.importLibrary('places');
    const PlaceAutocompleteElement = (placesLibrary as any).PlaceAutocompleteElement;
    this.autoComplete = new PlaceAutocompleteElement({
    componentRestrictions: { country: 'US' },
    types: ['locality'], // replaces the legacy-only '(cities)' collection
    });

    this.autoComplete.setAttribute('no-input-icon', '');
    this.autoComplete.setAttribute('no-clear-button', '');
    this.searchFieldContainer.nativeElement.innerHTML = '';
    this.searchFieldContainer.nativeElement.appendChild(this.autoComplete);
    this.autoComplete.addEventListener('focus', () => {
    this.isAddressFocused = true;
    this.changeDetect.detectChanges();
    });
    this.autoComplete.addEventListener('blur', () => {
    this.isAddressFocused = false;
    this.changeDetect.detectChanges();
    })
    this.autoComplete.addEventListener('input', () => {
    this.autoCompleteInput = this.autoComplete.value;
    this.changeDetect.detectChanges();
    });
    this.autoComplete.addEventListener('gmp-select', async (event: any) => {
    const place = event.placePrediction.toPlace();
    await place.fetchFields({ fields: ['formattedAddress'] });
    new google.maps.Geocoder().geocode({ address: place.formattedAddress }, (results, status) => {
    if (status === google.maps.GeocoderStatus.OK && results && results.length) {
    this.userAddress = results[0];
    this.addAddress();
    }
    });
    this.autoComplete.value = '';
    });
  }


  // initAutoComplete() {
  //   this.autoComplete = new google.maps.places.Autocomplete(this.search.nativeElement, {
  //     componentRestrictions: { country: 'US' },
  //     types: ['(cities)'],
  //   });
  //   google.maps.event.addListener(this.autoComplete, 'place_changed', () => {
  //     const place: google.maps.places.PlaceResult = this.autoComplete.getPlace();
  //     if (place && place.address_components) {
  //       this.userAddress = place;
  //       this.addAddress();
  //     }
  //   });
  // }
  getPlaceFromGeocoder() {
    new google.maps.Geocoder().geocode({ address: this.f.autoCompleteInput.value }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results && results.length) {
        this.userAddress = results[0];
      }
    });
  }

  /**
   * Authenticates an existing user.
   *
   * Interceptor flow:
   * - Close with `{ success: true }`.
   * - Do not navigate away.
   * - The interceptor retries the original failed API request.
   *
   * Normal flow:
   * - Keep the existing expired-listing handling.
   * - Keep the existing post-login navigation.
   * - Keep the encrypted client-details handling.
   */
  authenticate(loginForm): void {
    this.signupStatus = false;

    if (!loginForm.valid || this.isUserAuthenticationProgress) {
      return;
    }
    this.openClientDetailsSheet = this.activatedRoute.snapshot.queryParamMap.get('openClientDetails');
    this.encryptedData = this.activatedRoute.snapshot.queryParamMap.get('encryptedData');
    if (this.encryptedData && this.openClientDetailsSheet) {
      this.clientDashboardService
        .decryptClientDetails({ identifier: this.encryptedData })
        .pipe(take(1))
        .subscribe((response: any) => {
          this.clientDashboardState.activeClientDetailsValue = response.data;
          this.clientDashboardState.openClientDetailsSheetValue = true;
        });
    }

    this.isUserAuthenticationProgress = true;

    const email = loginForm.value.email.trim().toLowerCase();
    const password = loginForm.value.password;

    this.loginService
      .userAuthenticate(email, password)
      .pipe(
        takeUntil(this.onDestroyNotifier$),
        finalize(() => {
          this.isUserAuthenticationProgress = false;

          // Reset any previous login error after a short delay.
          setTimeout(() => {
            this.loginAlerts = errorObj;
          }, 3000);
        })
      )
      .subscribe(
        (res: any) => {
          /**
           * When opened by HttpInterceptorService, return a clear success
           * result. The interceptor will read the latest token cookies and
           * retry the original request, such as fetchResearchStoreReport.
           */
          if (this.completeInterceptorAuthentication(res)) {
            return;
          }

          /**
           * Preserve the existing expired-listings flow.
           * The dialog is closed inside getExpiredListings after data loads.
           */
          if (this.tab === 'expiredListings') {
            this.getExpiredListings({
              page: 1,
              pageSize: 2,
            });
          } else {
            this.dialogRef.close();
          }

          const roles = res?.data?.userRoleList || [];

          // Preserve the reusable normal post-login navigation.
          this.loginService.navigatePostLogin(roles);

          /**
           * Preserve the existing client-details deep-link flow.
           */

        },
        (err) => {
          this.loginAlerts = {
            type: 'error',
            message: err?.error?.message || err?.message || 'Authentication failed',
          };
        }
      );
  }

  /**
   * Closes the dialog with the result expected by HttpInterceptorService.
   *
   * Returns true when the interceptor flow was handled, so the caller can
   * stop normal navigation and other page-specific actions.
   */
  private completeInterceptorAuthentication(response: any): boolean {
    if (!this.data?.openedFromInterceptor) {
      return false;
    }

    this.dialogRef.close({
      success: true,
      response,
    });

    return true;
  }

  sendPasswordResetLink(data: string) {
    if (!this.forgotPasswordForm.valid) {
      return false;
    }
    this.resetLinkInprogress = true;
    this.forgotPasswordService
      .getPasswordResetLink(data)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (res: { Message: string }) => {
          this.resetLinkInprogress = false;
          if (res && res.Message) {
            this.onNoClick();
            this.dialog.open(DialogComponent, {
              width: '355px',
              data: {
                type: 'resetLink',
                message: 'A reset link has been sent to your registered email',
                title: 'Reset Email Sent',
              },
            });
            this.resetPasswordAlerts = { type: 'info', message: res.Message };
            this.forgotPasswordForm.resetForm();
            setTimeout(() => {
              this.resetPasswordAlerts = errorObj;
            }, 3000);
          }
        },
        (error: { Message: string }) => {
          this.resetLinkInprogress = false;
          this.resetPasswordAlerts = { type: 'danger', message: error.Message };
          setTimeout(() => {
            this.resetPasswordAlerts = errorObj;
          }, 3000);
        }
      );
  }
  getClientInfo() {
    if (this.userId) {
      if (
        (this.appState.clientInfoSubValue &&
          this.appState.clientInfoSubValue.user &&
          this.appState.clientInfoSubValue.user.id != this.userId) ||
        (this.appState.clientInfoSubValue && !this.appState.clientInfoSubValue.user)
      ) {
        const param = { id: this.userId };
        this.appService.getBrandingPartnersInfo(param).pipe(takeUntil(this.onDestroyNotifier$)).subscribe();
      }
    }
  }

  private getExpiredListings(params: any) {
    this.listingService
      .fetchExpiredListings(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (res: any) => {
          if (res) {
            const listings = res.data || [];
            this.clientDashboardState.expiredListValue = listings;
            this.dialogRef.close();
          }

        },
        (err) => {
          this.clientDashboardState.expiredListValue = [];
          console.error(err);
        }
      );
  }

  get formValueForResetPwd() {
    return { passCode: '', password: '', confirmPassword: '' };
  }

  /**
   * Closes the main dialog.
   *
   * For the interceptor flow, return an explicit cancellation result so the
   * original protected request is not retried without authentication.
   *
   * For normal usage, preserve the old `close()` behaviour.
   */
  onNoClick(): void {
    if (this.data?.openedFromInterceptor) {
      this.dialogRef.close({
        success: false,
        cancelled: true,
      });
      return;
    }

    this.dialogRef.close();
  }

  /**
   * Preserves the existing signup-success notification behaviour.
   */
  onInfoNoClick(): void {
    if (this.data?.openedFromInterceptor) {
      this.dialogRef.close({
        success: false,
        cancelled: true,
      });
    } else {
      this.dialogRef.close();
    }

    this.userState.notifySignupSuccessClosed = true;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

}